<div *ngIf="showUpButton" class="collapse-button" (click)="up()" fxLayoutAlign="center center"></div>
<div style="border-top: 1px solid black"></div>
<div class="expand-button" (click)="down()"></div>
